import React , { useState, useEffect } from 'react';

import {makeStyles} from "@material-ui/core/styles";


// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
import Button from "@material-ui/core/Button";
import fontb from '../../B-NAZANIN.TTF';
import fontb2 from '../../btitr.ttf';
import ReactFontFace from 'react-font-face'
import {Redirect} from "react-router";
import {createMuiTheme, ThemeProvider} from '@material-ui/core/styles';
import Charts from "../Charts/Charts";
import DeleteIcon from '@material-ui/icons/Delete';
import './Labeling.css';
import Checkbox from "@material-ui/core/Checkbox";
import {Grid, Segment} from 'semantic-ui-react'

import Dialog from '@material-ui/core/Dialog';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import InputLabel from "@material-ui/core/InputLabel";
import CircularProgress from '@material-ui/core/CircularProgress';
import LinearProgress from '@material-ui/core/LinearProgress';
import useMediaQuery from '@material-ui/core/useMediaQuery';

let theme2 = createMuiTheme();

theme2.typography.h2 = {

    [theme2.breakpoints.up('md')]: {
        fontSize: 25,
    },
    // [theme2.breakpoints.up('xs')]: {
    // fontSize: 1,
    // },
    [theme2.breakpoints.down('sm')]: {
        fontSize: 19,
    },
};
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
let fontConfig = {

    file: [
        {
            fontFamily: 'Bnazanin',
            fontStyle: 'normal',
            fontWeight: 400,
            // unicodeRange: 'U+0000-00FF, U+0131, U+0152-0153, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2212, U+2215',
            file: fontb,
            fontType: 'truetype',
            // fileLocal: 'Bangers Regular'
        },
        {
            fontFamily: 'Btitr',
            fontStyle: 'normal',
            fontWeight: 400,
            // unicodeRange: 'U+0000-00FF, U+0131, U+0152-0153, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2212, U+2215',
            file: fontb2,
            fontType: 'truetype',
            // fileLocal: 'Bangers Regular'
        }


    ]
}
const MatchMediaWrapper = ({mobileContent, desktopContent}) => {
    const [isNarrowScreen, setIsNarrowScreen] = useState(false)
    useEffect(() => {
        const mediaWatcher = window.matchMedia("(max-width: 1230px)")
        setIsNarrowScreen(mediaWatcher.matches);

        function updateIsNarrowScreen(e) {
            setIsNarrowScreen(e.matches);
        }
        if(mediaWatcher.addEventListener) {
            mediaWatcher.addEventListener('change', updateIsNarrowScreen)
            return function cleanup() {
                mediaWatcher.removeEventListener('change', updateIsNarrowScreen)
            }
        } else {
            mediaWatcher.addListener(updateIsNarrowScreen)
            return function cleanup() {
                mediaWatcher.removeListener(updateIsNarrowScreen)
            }
        }
    })
    return isNarrowScreen ? mobileContent : desktopContent;
}
class Labeling extends React.Component {
    constructor(props) {

        super(props);

        this.state = {
            NSample: 0,
            matches: window.matchMedia("(max-width: 830px)").matches,
            samples: null,
            Subject: "زبان",
            NTopicsExist: false,
            input_sample: [],
            NTopics: null,
            NTopics2: null,
            open: false,
            input: [],
            classes: makeStyles(styles),
            Load: false,
            response: null,
            input2: [],
            // input:[],
            // classes: makeStyles(styles),

            // response:null,
            // input2:[],
        };

        this.handleChange3 = this.handleChange3.bind(this);
        // window.matchMedia("(min-width: 768px)").addListener(this.handler6);
        // this.handleChange1 = this.handleChange6.bind(this);
        // this.handler6 = this.handler6.bind(this);
    }

    componentDidMount() {

	//        fetch("http://conalysis.ihcs.ac.ir:8080/determine_ntopic", {
	        fetch("http://conalysis.ihcs.ac.ir:8080/determine_ntopic", {

            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                // label: this.state.input[index],
                subject: 'زبان',
                // topic_version:value.topics_version,
                // email:this.props.location.state.email
            }),
        })
            .then((response) => response.json())
            .then((responseJson) => {
                //   console.log("hello")
                console.log(responseJson);
                if (responseJson.exist) {

                    this.setState({
                        NTopics: responseJson.topic_ids,
                        NTopicsExist: true,
                        NTopics2: responseJson.topic_ids[0].ntopic,
                    })
                } else {
                    this.setState({
                        NTopicsExist: false,
                    })

                }


            })
            .catch((error) => {
                console.log(error);
            });


    }

    sentLabelData() {
        this.setState({
            Load: true,
            input2: [],
            response: null,
            input: [],

        })
	//        fetch("http://conalysis.ihcs.ac.ir:8080/get_topics", {
	        fetch("http://conalysis.ihcs.ac.ir:8080/get_topics", {

            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                subject: this.state.Subject,
                ntopic: this.state.NTopics2,
                email: this.props.location.state.email
            }),
        })
            .then((response) => response.json())
            .then((responseJson) => {
                console.log(responseJson);
                //console.log("sda")

                this.setState({
                    response: responseJson,
                });
                for (var i = 0; i < this.state.response.length; i++) {
                    this.setState({input_sample: [...this.state.input_sample, 0]})
                }


            })
            .catch((error) => {
                console.log(error);
            });
        if (this.props.location.state.user_level == 2) {
            console.log("injam")
	    //            fetch("http://conalysis.ihcs.ac.ir:8080/get_labels_admin", {
	                fetch("http://conalysis.ihcs.ac.ir:8080/get_labels_admin", {

                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    subject: this.state.Subject,
                    ntopic: this.state.NTopics2,
                    email: this.props.location.state.email
                }),
            })
                .then((response) => response.json())
                .then((responseJson) => {
                    console.log(responseJson);

                    // var input2=responseJson

                    this.setState({
                        input2: responseJson,
                    });
                    console.log(this.state.input2);

                })
                .catch((error) => {
                    console.log(error);
                });


        }
	//        fetch("http://conalysis.ihcs.ac.ir:8080/get_labels", {
	        fetch("http://conalysis.ihcs.ac.ir:8080/get_labels", {

            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                subject: this.state.Subject,
                ntopic: this.state.NTopics2,
                email: this.props.location.state.email
                // user_level: this.state.NWord,
                // type:'1',
            }),
        })
            .then((response) => response.json())
            .then((responseJson) => {
                console.log(responseJson);

                var input2 = responseJson

                this.setState({
                    input: responseJson,
                    Load: false,
                });
                // this.setState({
                //     Load: true,
                // })
                // console.log(this.state.input);

            })
            .catch((error) => {
                console.log(error);
            });


    }

    handleClickOpen(option, index) {
        console.log(option)
	//        fetch("http://conalysis.ihcs.ac.ir:8080/get_samples", {
	        fetch("http://conalysis.ihcs.ac.ir:8080/get_samples", {

            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({

                NSample: this.state.input_sample[index],
                topic_id: option.topic_id,
                subject: option.subject,
                ntopic: option.ntopic
                // type:'1',
            }),
        })
            .then((response) => response.json())
            .then((responseJson) => {
                console.log(responseJson);
                this.setState({
                    open: true,
                    samples: responseJson
                })
            })
            .catch((error) => {
                console.log(error);
            });


        // setOpen(true);
    };

    handleClose() {
        this.setState({
            open: false
        })
    };

    //   handleChange = e => {
    //     if(e.target.value >=0){
    //     this.setState({
    //         NSample: +e.target.value || 0,
    //     });
    // }
    // };
    handleChange1 = e => {

        if (e.target.value >= 0) {
            this.setState({
                NTopics2: +e.target.value || 0,
            });
        }
        console.log(e.target.value)
    };
    // handleInputChange(option, index){
    //     var input = [...this.state.input];
    //     console.log(input)
    //     input.splice(index, 1, input);
    //     this.setState({
    //         input
    //     });
    //   };
    // handleChange1 = e => {
    //         var i =this.state.input;
    //         i[]
    //         this.setState({
    //             input: e.target.value,
    //         });
    // };
    handleChange3(event) {
        // console.log(this.state.value);


	//        fetch("http://conalysis.ihcs.ac.ir:8080/determine_ntopic", {
	        fetch("http://conalysis.ihcs.ac.ir:8080/determine_ntopic", {

            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                // label: this.state.input[index],
                subject: event.target.value,
                // topic_version:value.topics_version,
                // email:this.props.location.state.email
            }),
        })
            .then((response) => response.json())
            .then((responseJson) => {

                console.log(responseJson);
                if (responseJson.exist) {

                    this.setState({
                        NTopics: responseJson.topic_ids,
                        NTopicsExist: true,
                        NTopics2: responseJson.topic_ids[0].ntopic,
                    })
                } else {
                    this.setState({
                        NTopicsExist: false,
                    })

                }


            })
            .catch((error) => {
                console.log(error);
            });

        this.setState({Subject: event.target.value});

    }
    // handler6 = e => this.setState({matches: e.matches});
    // handler6(event) {
    //     console.log("he21")
    //     // this.setState({matches: e.matches});
    //     this.setState({matches: window.matchMedia("(max-width: 830px)").matches});
    //
    // }
    render() {

        return (

            <div>
                <GridContainer>
                    {/*{this.handler6()}*/}
                    <Button
                        // className="button"
                        style={{
                            marginTop: "-5%",
                            marginRight: "95%",
                            borderRadius: "20px",
                            fontFamily: "Btitr",
                            fontSize: 16,
                            width: "2%",
                            height: "3%",
                            backgroundColor: "rgb(0,191,214)"
                        }}
                        onClick={() => {
                            this.setState({
                                action: true
                            })
                        }

                        }
                        // onClick={this.handleSubmit}
                    >
                        خروج
                    </Button>
                    {
                        this.state.action ? <div>{this.check22()}</div> : null
                    }

                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader color="primary">
                                <h4 className={this.state.classes.cardTitleWhite}
                                    style={{fontFamily: 'Bnazanin', fontSize: 29}}>برچسب‌گذاری</h4>

                            </CardHeader>
                            <CardBody>
                                <MatchMediaWrapper mobileContent={ <div style={{flexDirection: "column", display: "flex",}}>
                                    <div style={{width: "40%"}}>
                                        <InputLabel style={{
                                            width: "100%",
                                            fontSize: 25,
                                            fontFamily: 'Bnazanin',
                                            color: "black"
                                        }} htmlFor="select">حوزه علمی:</InputLabel>
                                        <select style={{
                                            width: "auto",
                                            fontSize: 19,
                                            fontFamily: 'Bnazanin',
                                            marginTop: "3%"
                                        }}
                                                value={this.state.Subject} onChange={this.handleChange3}>
                                            <option value="اقتصاد"
                                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>اقتصاد
                                            </option>
                                            <option value="ادبیات"
                                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>ادبیات
                                            </option>
                                            <option value="تربیت بدنی"
                                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>تربیت بدنی
                                            </option>
                                            <option value="تاریخ"
                                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>تاریخ
                                            </option>
                                            <option value="جغرافیا"
                                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>جغرافیا
                                            </option>
                                            <option value="حقوق"
                                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>حقوق
                                            </option>
                                            <option value="روانشناسی علوم تربیتی"
                                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>روان‌شناسی و علوم تربیتی
                                            </option>
                                            <option value="زبان"
                                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>زبان‌شناسی
                                            </option>
                                            {/* <option value="سیاست" style={{fontFamily:'Bnazanin',fontSize:25}}>سیاست</option> */}
                                            {/* <option value="علوم انسانی" style={{fontFamily:'Bnazanin',fontSize:25}}>علوم انسانی</option> */}
                                            <option value="علوم اسلامی"
                                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>علوم اسلامی
                                            </option>
                                            <option value="علوم کتابداری"
                                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>علوم کتابداری
                                            </option>
                                            <option value="علوم اجتماعی ارتباطات"
                                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>علوم اجتماعی   و ارتباطات
                                            </option>
                                            <option value="علوم سیاسی روابط الملل"
                                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>علوم سیاسی و  روابط بین‌الملل
                                            </option>
                                            <option value="فلسفه منطق"
                                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>فلسفه و منطق
                                            </option>
                                            <option value="مدیریت حسابداری"
                                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>مدیریت و  حسابداری
                                            </option>

                                            <option value="مطالعات هنر"
                                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>مطالعات هنر
                                            </option>


                                            <option value="مطالعات زنان"
                                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>مطالعات زنان
                                            </option>


                                            {/* <option value="نشریات میان رشته‌ای" style={{fontFamily:'Bnazanin',fontSize:25}}>نشریات میان رشته‌ای</option> */}
                                        </select>
                                    </div>
                                    <div style={{width: "40%"}}>
                                        <InputLabel style={{
                                            width: "100%",
                                            fontSize: 25,
                                            fontFamily: 'Bnazanin',
                                            color: "black"
                                        }} htmlFor="select">تعداد موضوع:</InputLabel>
                                        <select style={{
                                            width: "auto",
                                            fontFamily: 'Bnazanin',
                                            fontSize: 19,
                                            marginTop: "3%"
                                        }}
                                                value={this.state.NTopics2} onChange={this.handleChange1}>
                                            {
                                                this.state.NTopicsExist ?
                                                    this.state.NTopics.map((option, index) => {
                                                        return (
                                                            <option value={option.ntopic} style={{
                                                                fontFamily: 'Bnazanin',
                                                                fontSize: 25
                                                            }}>{option.ntopic}</option>

                                                        )


                                                    })


                                                    :
                                                    <option style={{fontFamily: 'Bnazanin', fontSize: 25}}>موجود
                                                        نیست</option>


                                            }

                                            {/* <option value="نشریات میان رشته‌ای" style={{fontFamily:'Bnazanin',fontSize:25}}>نشریات میان رشته‌ای</option> */}
                                        </select>
                                    </div>
                                </div>}
                                                   desktopContent={  <div style={{flexDirection: "row", display: "flex",}}>
                                    <div style={{width: "40%"}}>
                                        <InputLabel style={{
                                            width: "100%",
                                            fontSize: 25,
                                            fontFamily: 'Bnazanin',
                                            color: "black"
                                        }} htmlFor="select">حوزه علمی:</InputLabel>
                                        <select style={{
                                            width: "auto",
                                            fontSize: 19,
                                            fontFamily: 'Bnazanin',
                                            marginTop: "3%"
                                        }}
                                                value={this.state.Subject} onChange={this.handleChange3}>
                                            <option value="اقتصاد"
                                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>اقتصاد
                                            </option>
                                            <option value="ادبیات"
                                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>ادبیات
                                            </option>
                                            <option value="تربیت بدنی"
                                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>تربیت بدنی
                                            </option>
                                            <option value="تاریخ"
                                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>تاریخ
                                            </option>
                                            <option value="جغرافیا"
                                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>جغرافیا
                                            </option>
                                            <option value="حقوق"
                                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>حقوق
                                            </option>
                                            <option value="روانشناسی علوم تربیتی"
                                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>روان‌شناسی و  علوم تربیتی
                                            </option>
                                            <option value="زبان"
                                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>زبان‌شناسی
                                            </option>
                                            {/* <option value="سیاست" style={{fontFamily:'Bnazanin',fontSize:25}}>سیاست</option> */}
                                            {/* <option value="علوم انسانی" style={{fontFamily:'Bnazanin',fontSize:25}}>علوم انسانی</option> */}
                                            <option value="علوم اسلامی"
                                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>علوم اسلامی
                                            </option>
                                            <option value="علوم کتابداری"
                                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>علوم کتابداری
                                            </option>
                                            <option value="علوم اجتماعی ارتباطات"
                                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>علوم اجتماعی  و ارتباطات
                                            </option>
                                            <option value="علوم سیاسی روابط الملل"
                                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>علوم سیاسی و   روابط بین‌الملل
                                            </option>
                                            <option value="فلسفه منطق"
                                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>فلسفه و منطق
                                            </option>
                                            <option value="مدیریت حسابداری"
                                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>مدیریت و    حسابداری
                                            </option>

                                            <option value="مطالعات هنر"
                                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>مطالعات هنر
                                            </option>


                                            <option value="مطالعات زنان"
                                                    style={{fontFamily: 'Bnazanin', fontSize: 25}}>مطالعات زنان
                                            </option>


                                            {/* <option value="نشریات میان رشته‌ای" style={{fontFamily:'Bnazanin',fontSize:25}}>نشریات میان رشته‌ای</option> */}
                                        </select>
                                    </div>
                                    <div style={{width: "40%"}}>
                                        <InputLabel style={{
                                            width: "100%",
                                            fontSize: 25,
                                            fontFamily: 'Bnazanin',
                                            color: "black"
                                        }} htmlFor="select">تعداد موضوع:</InputLabel>
                                        <select style={{
                                            width: "auto",
                                            fontSize: 19,
                                            fontFamily: 'Bnazanin',
                                            marginTop: "3%"
                                        }}
                                                value={this.state.NTopics2} onChange={this.handleChange1}>
                                            {
                                                (this.state.NTopicsExist) ?
                                                    this.state.NTopics.map((option, index) => {
                                                        return (
                                                            <option value={option.ntopic} style={{
                                                                fontFamily: 'Bnazanin',
                                                                fontSize: 25
                                                            }}>{option.ntopic}</option>

                                                        )


                                                    })


                                                    :
                                                    <option style={{fontFamily: 'Bnazanin', fontSize: 25}}>موجود
                                                        نیست</option>


                                            }


                                            {/* <option value="نشریات میان رشته‌ای" style={{fontFamily:'Bnazanin',fontSize:25}}>نشریات میان رشته‌ای</option> */}
                                        </select>
                                    </div>
                                </div>}/>
                                <div                                     style={{
                                            width: "100%",
                                            fontSize: 25,
                                            fontFamily: 'Bnazanin',
                                            color: "black",
                                            marginTop: "8%"
                                        }}>
                                <a href={`/material-dashboard-react/static/LDAVisualization-${this.state.NTopics2}-${this.state.Subject}.html`} target="_blank" >نمایش بصری </a>
                                 </div>

                                <div
                                    style={{marginTop: "6%", width: "100%", display: 'flex', justifyContent: "center"}}>
                                    <Button
                                        className="button"
                                        style={{
                                            fontFamily: "Btitr",
                                            fontSize: 22,
                                            width: "10%",
                                            backgroundColor: "rgb(151,75,177)"
                                        }}
                                        onClick={() => this.sentLabelData()}

                                    >
                                        انتخاب
                                    </Button>
                                </div>


                                {
                                    this.state.Load ?
                                        <div style={{width: "100%", display: 'flex', justifyContent: "center"}}>
                                            {/*<LinearProgress />*/}
                                            <CircularProgress size={70}/>
                                        </div> : [
                                            (this.state.response ? this.state.response.map((option, index) => {

                                                    // var inputs=[]
                                                    // for(var i =0;i<option.lenght;i++){
                                                    //     inputs.push()

                                                    // }
                                                    // this.setState({
                                                    //     input[index]
                                                    // })
                                                    return (


                                                        <Card>
                                                            <CardHeader>


                                                                <div style={{
                                                                    position: "relative",

                                                                    direction: "ltr"
                                                                }}>
                                                                    <Charts words={option.words} freq={option.count}
                                                                            prop={option.weight} topic_id={option.topic_id}/>

                                                                </  div>

                                                                {/* {this.state.response ? */}
                                                                {this.state.response ? this.state.input2.map((option1, index1) => {
                                                                        //   {

                                                                        // this.state.input2.map((option2, index2) => {
                                                                        return (

                                                                            <div className="contaner_buttons">
                                                                                {/* <div style={{flexDirection: 'row',alignItems:"center",
        display: 'flex' }}> */}
                                                                                <label style={{
                                                                                    color: "black",
                                                                                    fontFamily: "Btitr",
                                                                                }}> برچسب
                                                                                    توسط {option1[1]}:</label>
                                                                                <input disabled style={{marginRight: "2%"}}
                                                                                    //    style={{width: "100%",marginRight:"1%"}}
                                                                                       value={option1[0][index]}
                                                                                    //    onChange={this.handleInputChange(option,index)}
                                                                                    //   onChange={(e)=>{
                                                                                    //       console.log(index)
                                                                                    //       var input1 = [...this.state.input];

                                                                                    //       input1.splice(index, 1, e.target.value);
                                                                                    //       this.setState({
                                                                                    //           input:input1
                                                                                    //       });
                                                                                    //       console.log(this.state.input[index])
                                                                                    //   }}
                                                                                />
                                                                                <Button variant="contained" style={{
                                                                                    fontFamily: "Btitr",
                                                                                    marginRight: 5,
                                                                                    backgroundColor: "rgb(46,96,95)",
                                                                                    color: "white"
                                                                                }} onClick={() => {
                                                                                    var input1 = [...this.state.input];

                                                                                    input1.splice(index, 1, option1[0][index]);
                                                                                    this.setState({
                                                                                        input: input1
                                                                                    });
                                                                                }} component="span">
                                                                                    انتخاب
                                                                                </Button>

                                                                            </div>

                                                                        )
                                                                        // }
                                                                        // )
                                                                        // }
                                                                    })

                                                                    : null

                                                                }
                                                                <MatchMediaWrapper
                                                                         desktopContent={
                                                                    <div style={{
                                                                        flexDirection: 'row', alignItems: "center",
                                                                        display: 'flex',width:"100%"
                                                                    }}>
                                                                        <div style={{flexDirection: 'row', alignItems: "center",
                                                                            display: 'flex',width:"50%"}}>
                                                                            <label style={{
                                                                                color: "black",
                                                                                fontFamily: "Bnazanin",fontSize: 19,
                                                                            }}> برچسب:</label>


                                                                            <input style={{
                                                                                height: "50%",
                                                                                marginRight: "2%",
                                                                                fontFamily: "Bnazanin",
                                                                                fontSize: 19,
                                                                            }}
                                                                                //    style={{width: "100%",marginRight:"1%"}}
                                                                                   value={this.state.input[index]}
                                                                                //    onChange={this.handleInputChange(option,index)}
                                                                                   onChange={(e) => {
                                                                                       console.log(index)
                                                                                       var input1 = [...this.state.input];

                                                                                       input1.splice(index, 1, e.target.value);
                                                                                       this.setState({
                                                                                           input: input1
                                                                                       });
                                                                                       console.log(this.state.input[index])
                                                                                   }}
                                                                            />
                                                                            <Button
                                                                                variant="contained"
                                                                                color="primary"
                                                                                style={{marginRight: 5, fontFamily: "Btitr",}}
                                                                                // className="submit_button"
                                                                                // endIcon={<Icon>send</Icon>}
                                                                                onClick={() => this.sentlabel(index, option)}
                                                                            >
                                                                                ثبت
                                                                            </Button>
                                                                            <Button
                                                                                variant="contained"
                                                                                color="secondary"
                                                                                style={{marginRight: 5, fontFamily: "Btitr",width:"auto"}}
                                                                                // className="delete_button"
                                                                                onClick={() => this.deletelabel(index, option)}
                                                                                endIcon={<DeleteIcon style={{marginRight: 5}}/>}
                                                                            >
                                                                                حذف
                                                                            </Button>
                                                                        </div>
                                                                        <div style={{
                                                                            flexDirection: 'row', alignItems: "center",
                                                                            display: 'flex',width:"50%"
                                                                        }}>
                                                                            <label style={{
                                                                                color: "black",
                                                                                fontFamily: "Bnazanin",
                                                                                marginRight: "5%",
                                                                                fontSize: 19,
                                                                            }}> تعداد شواهد:</label>


                                                                            <input
                                                                                style={{
                                                                                    marginRight: "1%",
                                                                                    fontFamily: "Bnazanin",
                                                                                    fontSize: 19,
                                                                                }}
                                                                                type="number"

                                                                                value={this.state.input_sample[index]}
                                                                                //    onChange={this.handleChange}
                                                                                onChange={(e) => {
                                                                                    if (e.target.value >= 0 && e.target.value <= 50) {
                                                                                        var input1 = [...this.state.input_sample];

                                                                                        input1.splice(index, 1, e.target.value);
                                                                                        this.setState({
                                                                                            input_sample: input1
                                                                                        });
                                                                                    }
                                                                                }}
                                                                            />

                                                                            <Button variant="outlined" color="primary"
                                                                                    style={{
                                                                                        marginRight: 5,
                                                                                        fontFamily: "Bnazanin",
                                                                                        fontSize: 19,
                                                                                        height: "50%",
                                                                                        width:"auto"
                                                                                    }}
                                                                                    onClick={() => this.handleClickOpen(option, index)}>
                                                                                مشاهده شواهد
                                                                            </Button>
                                                                            <Dialog fullScreen open={this.state.open}
                                                                                    onClose={() => this.handleClose()}
                                                                                    TransitionComponent={Transition}>
                                                                                <AppBar style={{position: 'relative'}}>
                                                                                    <Toolbar>
                                                                                        <IconButton edge="start" color="inherit"
                                                                                                    onClick={() => this.handleClose()}
                                                                                                    aria-label="close">
                                                                                            <CloseIcon/>
                                                                                        </IconButton>
                                                                                        <Typography variant="h6" style={{
                                                                                            width: '100%',
                                                                                            textAlign: "right",
                                                                                            fontFamily: "Btitr",
                                                                                        }}>
                                                                                            {
                                                                                                this.state.samples ?
                                                                                                    <div>{'  موضوع' + this.state.samples[0]}</div> : null

                                                                                            }
                                                                                        </Typography>
                                                                                        {/* <Button autoFocus color="inherit" onClick={()=>this.handleClose()}>
              save
            </Button> */}
                                                                                    </Toolbar>
                                                                                </AppBar>
                                                                                <div>
                                                                                    {this.state.samples ? this.state.samples[1].map((value, index3) => {
                                                                                        return (
                                                                                            <Card>
                                                                                                <CardHeader>
                                                                                                    <div style={{
                                                                                                        width: '100%',
                                                                                                        textAlign: "right",
                                                                                                        fontWeight: 'bold',
                                                                                                        fontFamily: "Btitr",
                                                                                                        fontSize: 20,
                                                                                                    }}>
                                                                                                        {":عنوان"}
                                                                                                    </div>
                                                                                                    <div style={{
                                                                                                        textAlign: "right",
                                                                                                        fontFamily: 'Bnazanin',
                                                                                                        fontSize: 25
                                                                                                    }}>
                                                                                                        {value[1]}
                                                                                                    </div>
                                                                                                    <div style={{
                                                                                                        width: "100%",
                                                                                                        textAlign: "right",
                                                                                                        fontWeight: 'bold',
                                                                                                        fontFamily: "Btitr",
                                                                                                        fontSize: 20,
                                                                                                    }}>
                                                                                                        {":چکیده"}
                                                                                                    </div>
                                                                                                    <div style={{
                                                                                                        width: "100%",
                                                                                                        textAlign: "right",
                                                                                                        fontFamily: 'Bnazanin',
                                                                                                        fontSize: 25
                                                                                                    }}>
                                                                                                        {value[2]}
                                                                                                    </div>
                                                                                                    {/*<div style={{textAlign: "right"}}>*/}
                                                                                                    {/*    {value[0]}*/}
                                                                                                    {/*</div>*/}

                                                                                                </CardHeader>
                                                                                            </Card>

                                                                                        )
                                                                                    }) : null

                                                                                    }
                                                                                </div>
                                                                                {/* </CardHeader> */}
                                                                                {/* </Card> */}
                                                                            </Dialog>

                                                                        </div>
                                                                    </div>

                                                                    // )
                                                                }
                                                                    mobileContent={ <div>
                                                                    <div style={{flexDirection: 'row', alignItems: "center",
                                                                        display: 'flex',width:"50%"}}>
                                                                        <label style={{
                                                                            color: "black",
                                                                            fontFamily: "Bnazanin",
                                                                            fontSize: 19,
                                                                        }}> برچسب:</label>


                                                                        <input style={{
                                                                            height: "50%",
                                                                            marginRight: "2%",
                                                                            fontFamily: "Bnazanin",
                                                                            fontSize: 19,
                                                                        }}
                                                                            //    style={{width: "100%",marginRight:"1%"}}
                                                                               value={this.state.input[index]}
                                                                            //    onChange={this.handleInputChange(option,index)}
                                                                               onChange={(e) => {
                                                                                   console.log(index)
                                                                                   var input1 = [...this.state.input];

                                                                                   input1.splice(index, 1, e.target.value);
                                                                                   this.setState({
                                                                                       input: input1
                                                                                   });
                                                                                   console.log(this.state.input[index])
                                                                               }}
                                                                        />
                                                                        <Button
                                                                            variant="contained"
                                                                            color="primary"
                                                                            style={{marginRight: 5, fontFamily: "Btitr",}}
                                                                            // className="submit_button"
                                                                            // endIcon={<Icon>send</Icon>}
                                                                            onClick={() => this.sentlabel(index, option)}
                                                                        >
                                                                            ثبت
                                                                        </Button>
                                                                        <Button
                                                                            variant="contained"
                                                                            color="secondary"
                                                                            style={{marginRight: 5, fontFamily: "Btitr",}}
                                                                            // className="delete_button"
                                                                            onClick={() => this.deletelabel(index, option)}
                                                                            endIcon={<DeleteIcon style={{marginRight: 5}}/>}
                                                                        >
                                                                            حذف 
                                                                        </Button>
                                                                    </div>
                                                                    <div style={{
                                                                        flexDirection: 'row', alignItems: "center",
                                                                        display: 'flex',width:"50%"
                                                                    }}>
                                                                        <label style={{
                                                                            color: "black",
                                                                            fontFamily: "Bnazanin",
                                                                            fontSize: 19,
                                                                            // marginRight: "5%",
                                                                        }}> تعداد شواهد:</label>


                                                                        <input
                                                                            style={{
                                                                                marginRight: "1%",
                                                                                fontFamily: "Bnazanin",
                                                                                fontSize: 19,
                                                                            }}
                                                                            type="number"

                                                                            value={this.state.input_sample[index]}
                                                                            //    onChange={this.handleChange}
                                                                            onChange={(e) => {
                                                                                if (e.target.value >= 0 && e.target.value <= 50) {
                                                                                    var input1 = [...this.state.input_sample];

                                                                                    input1.splice(index, 1, e.target.value);
                                                                                    this.setState({
                                                                                        input_sample: input1
                                                                                    });
                                                                                }
                                                                            }}
                                                                        />

                                                                        <Button variant="outlined" color="primary"
                                                                                style={{
                                                                                    marginRight: 5,
                                                                                    fontFamily: "Bnazanin",
                                                                                    fontSize: 19,
                                                                                    height: "50%"
                                                                                }}
                                                                                onClick={() => this.handleClickOpen(option, index)}>
                                                                            مشاهده شواهد
                                                                        </Button>
                                                                        <Dialog fullScreen open={this.state.open}
                                                                                onClose={() => this.handleClose()}
                                                                                TransitionComponent={Transition}>
                                                                            <AppBar style={{position: 'relative'}}>
                                                                                <Toolbar>
                                                                                    <IconButton edge="start" color="inherit"
                                                                                                onClick={() => this.handleClose()}
                                                                                                aria-label="close">
                                                                                        <CloseIcon/>
                                                                                    </IconButton>
                                                                                    <Typography variant="h6" style={{
                                                                                        width: '100%',
                                                                                        textAlign: "right",
                                                                                        fontFamily: "Btitr",
                                                                                    }}>
                                                                                        {
                                                                                            this.state.samples ?
                                                                                                <div>{'  موضوع' + this.state.samples[0]}</div> : null

                                                                                        }
                                                                                    </Typography>
                                                                                    {/* <Button autoFocus color="inherit" onClick={()=>this.handleClose()}>
              save
            </Button> */}
                                                                                </Toolbar>
                                                                            </AppBar>
                                                                            <div>
                                                                                {this.state.samples ? this.state.samples[1].map((value, index3) => {
                                                                                    return (
                                                                                        <Card>
                                                                                            <CardHeader>
                                                                                                <div style={{
                                                                                                    width: '100%',
                                                                                                    textAlign: "right",
                                                                                                    fontWeight: 'bold',
                                                                                                    fontFamily: "Btitr",
                                                                                                    fontSize: 20,
                                                                                                }}>
                                                                                                    {":عنوان"}
                                                                                                </div>
                                                                                                <div style={{
                                                                                                    textAlign: "right",
                                                                                                    fontFamily: 'Bnazanin',
                                                                                                    fontSize: 25
                                                                                                }}>
                                                                                                    {value[1]}
                                                                                                </div>
                                                                                                <div style={{
                                                                                                    width: "100%",
                                                                                                    textAlign: "right",
                                                                                                    fontWeight: 'bold',
                                                                                                    fontSize: 20,
                                                                                                    fontFamily: "Btitr",
                                                                                                }}>
                                                                                                    {":چکیده"}
                                                                                                </div>
                                                                                                <div style={{
                                                                                                    width: "100%",
                                                                                                    textAlign: "right",
                                                                                                    fontFamily: 'Bnazanin',

                                                                                                    fontSize: 25
                                                                                                }}>
                                                                                                    {value[2]}
                                                                                                </div>
                                                                                                {/*<div style={{textAlign: "right"}}>*/}
                                                                                                {/*    {value[0]}*/}
                                                                                                {/*</div>*/}

                                                                                            </CardHeader>
                                                                                        </Card>

                                                                                    )
                                                                                }) : null

                                                                                }
                                                                            </div>
                                                                            {/* </CardHeader> */}
                                                                            {/* </Card> */}
                                                                        </Dialog>

                                                                    </div>
                                                                </div>}/>



        {/*                                                        <div style={{*/}
        {/*                                                            flexDirection: 'row', alignItems: "center",*/}
        {/*                                                            display: 'flex'*/}
        {/*                                                        }}>*/}
        {/*                                                            <div className="contaner_buttons">*/}
        {/*                                                                /!*<div style={{flexDirection: 'row',}}>*!/*/}
        {/*                                                                <div style={{*/}
        {/*                                                                    flexDirection: 'row', alignItems: "center",*/}
        {/*                                                                    display: 'flex'*/}
        {/*                                                                }}>*/}
        {/*                                                                    <label style={{*/}
        {/*                                                                        color: "black",*/}
        {/*                                                                        fontFamily: "Btitr",*/}
        {/*                                                                    }}> برچسب:</label>*/}


        {/*                                                                    <input style={{*/}
        {/*                                                                        height: "50%",*/}
        {/*                                                                        marginRight: "2%",*/}
        {/*                                                                        fontFamily: "Bnazanin",*/}
        {/*                                                                        fontSize: 19,*/}
        {/*                                                                    }}*/}
        {/*                                                                        //    style={{width: "100%",marginRight:"1%"}}*/}
        {/*                                                                           value={this.state.input[index]}*/}
        {/*                                                                        //    onChange={this.handleInputChange(option,index)}*/}
        {/*                                                                           onChange={(e) => {*/}
        {/*                                                                               console.log(index)*/}
        {/*                                                                               var input1 = [...this.state.input];*/}

        {/*                                                                               input1.splice(index, 1, e.target.value);*/}
        {/*                                                                               this.setState({*/}
        {/*                                                                                   input: input1*/}
        {/*                                                                               });*/}
        {/*                                                                               console.log(this.state.input[index])*/}
        {/*                                                                           }}*/}
        {/*                                                                    />*/}

        {/*                                                                </div>*/}

        {/*                                                                <div className="submit_button">*/}
        {/*                                                                    <Button*/}
        {/*                                                                        variant="contained"*/}
        {/*                                                                        color="primary"*/}
        {/*                                                                        style={{marginRight: 5, fontFamily: "Btitr",}}*/}
        {/*                                                                        // className="submit_button"*/}
        {/*                                                                        // endIcon={<Icon>send</Icon>}*/}
        {/*                                                                        onClick={() => this.sentlabel(index, option)}*/}
        {/*                                                                    >*/}
        {/*                                                                        ثبت*/}
        {/*                                                                    </Button>*/}
        {/*                                                                    <Button*/}
        {/*                                                                        variant="contained"*/}
        {/*                                                                        color="secondary"*/}
        {/*                                                                        style={{marginRight: 5, fontFamily: "Btitr",}}*/}
        {/*                                                                        // className="delete_button"*/}
        {/*                                                                        onClick={() => this.deletelabel(index, option)}*/}
        {/*                                                                        endIcon={<DeleteIcon style={{marginRight: 5}}/>}*/}
        {/*                                                                    >*/}
        {/*                                                                        حذف کردن*/}
        {/*                                                                    </Button>*/}
        {/*                                                                </div>*/}
        {/*                                                            </div>*/}


        {/*                                                            <div className="contaner_buttons">*/}
        {/*                                                                /!* <div style={{flexDirection: 'row',alignItems:"center",*/}
        {/*display: 'flex' }}> *!/*/}
        {/*                                                                <label style={{*/}
        {/*                                                                    color: "black",*/}
        {/*                                                                    fontFamily: "Btitr",*/}
        {/*                                                                    marginRight: "5%",*/}
        {/*                                                                }}> تعداد شواهد:</label>*/}


        {/*                                                                <input*/}
        {/*                                                                    style={{*/}
        {/*                                                                        marginRight: "1%",*/}
        {/*                                                                        fontFamily: "Bnazanin",*/}
        {/*                                                                        fontSize: 19,*/}
        {/*                                                                    }}*/}
        {/*                                                                    type="number"*/}

        {/*                                                                    value={this.state.input_sample[index]}*/}
        {/*                                                                    //    onChange={this.handleChange}*/}
        {/*                                                                    onChange={(e) => {*/}
        {/*                                                                        if (e.target.value >= 0) {*/}
        {/*                                                                            var input1 = [...this.state.input_sample];*/}

        {/*                                                                            input1.splice(index, 1, e.target.value);*/}
        {/*                                                                            this.setState({*/}
        {/*                                                                                input_sample: input1*/}
        {/*                                                                            });*/}
        {/*                                                                        }*/}
        {/*                                                                        // console.log(this.state.input[index])*/}
        {/*                                                                    }}*/}
        {/*                                                                />*/}

        {/*                                                                /!* </div>                                                      *!/*/}

        {/*                                                                <div className="submit_button" style={{height: "100%"}}>*/}

        {/*                                                                    <Button variant="outlined" color="primary"*/}
        {/*                                                                            style={{*/}
        {/*                                                                                marginRight: 5,*/}
        {/*                                                                                fontFamily: "Btitr",*/}
        {/*                                                                                height: "50%"*/}
        {/*                                                                            }}*/}
        {/*                                                                            onClick={() => this.handleClickOpen(option, index)}>*/}
        {/*                                                                        مشاهده شواهد*/}
        {/*                                                                    </Button>*/}
        {/*                                                                    <Dialog fullScreen open={this.state.open}*/}
        {/*                                                                            onClose={() => this.handleClose()}*/}
        {/*                                                                            TransitionComponent={Transition}>*/}
        {/*                                                                        <AppBar style={{position: 'relative'}}>*/}
        {/*                                                                            <Toolbar>*/}
        {/*                                                                                <IconButton edge="start" color="inherit"*/}
        {/*                                                                                            onClick={() => this.handleClose()}*/}
        {/*                                                                                            aria-label="close">*/}
        {/*                                                                                    <CloseIcon/>*/}
        {/*                                                                                </IconButton>*/}
        {/*                                                                                <Typography variant="h6" style={{*/}
        {/*                                                                                    width: '100%',*/}
        {/*                                                                                    textAlign: "right",*/}
        {/*                                                                                    fontFamily: "Btitr",*/}
        {/*                                                                                }}>*/}
        {/*                                                                                    {*/}
        {/*                                                                                        this.state.samples ?*/}
        {/*                                                                                            <div>{'  موضوع' + this.state.samples[0]}</div> : null*/}

        {/*                                                                                    }*/}
        {/*                                                                                </Typography>*/}
        {/*                                                                                /!* <Button autoFocus color="inherit" onClick={()=>this.handleClose()}>*/}
        {/*      save*/}
        {/*    </Button> *!/*/}
        {/*                                                                            </Toolbar>*/}
        {/*                                                                        </AppBar>*/}
        {/*                                                                        <div>*/}
        {/*                                                                            {this.state.samples ? this.state.samples[1].map((value, index3) => {*/}
        {/*                                                                                return (*/}
        {/*                                                                                    <Card>*/}
        {/*                                                                                        <CardHeader>*/}
        {/*                                                                                            <div style={{*/}
        {/*                                                                                                width: '100%',*/}
        {/*                                                                                                textAlign: "right",*/}
        {/*                                                                                                fontWeight: 'bold',*/}
        {/*                                                                                                fontFamily: "Btitr",*/}
        {/*                                                                                            }}>*/}
        {/*                                                                                                {":عنوان"}*/}
        {/*                                                                                            </div>*/}
        {/*                                                                                            <div style={{*/}
        {/*                                                                                                textAlign: "right",*/}
        {/*                                                                                                fontFamily: 'Bnazanin',*/}
        {/*                                                                                                fontSize: 25*/}
        {/*                                                                                            }}>*/}
        {/*                                                                                                {value[1]}*/}
        {/*                                                                                            </div>*/}
        {/*                                                                                            <div style={{*/}
        {/*                                                                                                width: "100%",*/}
        {/*                                                                                                textAlign: "right",*/}
        {/*                                                                                                fontWeight: 'bold',*/}
        {/*                                                                                                fontFamily: "Btitr",*/}
        {/*                                                                                            }}>*/}
        {/*                                                                                                {":چکیده"}*/}
        {/*                                                                                            </div>*/}
        {/*                                                                                            <div style={{*/}
        {/*                                                                                                width: "100%",*/}
        {/*                                                                                                textAlign: "right",*/}
        {/*                                                                                                fontFamily: 'Bnazanin',*/}
        {/*                                                                                                fontSize: 25*/}
        {/*                                                                                            }}>*/}
        {/*                                                                                                {value[2]}*/}
        {/*                                                                                            </div>*/}
        {/*                                                                                            /!*<div style={{textAlign: "right"}}>*!/*/}
        {/*                                                                                            /!*    {value[0]}*!/*/}
        {/*                                                                                            /!*</div>*!/*/}

        {/*                                                                                        </CardHeader>*/}
        {/*                                                                                    </Card>*/}

        {/*                                                                                )*/}
        {/*                                                                            }) : null*/}

        {/*                                                                            }*/}
        {/*                                                                        </div>*/}
        {/*                                                                        /!* </CardHeader> *!/*/}
        {/*                                                                        /!* </Card> *!/*/}
        {/*                                                                    </Dialog>*/}
        {/*                                                                </div>*/}

        {/*                                                            </div>*/}
        {/*                                                        </div>*/}
                                                            </ CardHeader>
                                                        </Card>
                                                    )
                                                })

                                                : null),
                                        ]

                                    // return(

                                    // )

                                }
                                {/*<CircularProgress style={{width:200}}/>*/
                                }
                            </CardBody>
                        </Card>


                    </GridItem>

                </GridContainer>

            </div>
        );


        // }

    }

    sentlabel(index, value) {
        console.log(this.state.input);


//        fetch("http://conalysis.ihcs.ac.ir:8080/set_label", {

        fetch("http://conalysis.ihcs.ac.ir:8080/set_label", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                label: this.state.input[index],
                topic_id: value.topic_id,
                subject: value.subject,
                ntopic: value.ntopic,
                email: this.props.location.state.email
            }),
        })
            .then((response) => response.json())
            .then((responseJson) => {
                console.log(responseJson);


                // this.setState({
                //     response: responseJson,
                // });


            })
            .catch((error) => {
                console.log(error);
            });

    }

    deletelabel(index, value) {
        console.log(this.state.input);


	//        fetch("http://conalysis.ihcs.ac.ir:8080/delete_label", {
	        fetch("http://conalysis.ihcs.ac.ir:8080/delete_label", {

            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                label: this.state.input[index],
                topic_id: value.topic_id,
                subject: this.state.Subject,
                email: this.props.location.state.email
            }),
        })
            .then((response) => response.json())
            .then((responseJson) => {
                console.log(responseJson);

                var input1 = [...this.state.input];

                input1.splice(index, 1, '');
                this.setState({
                    input: input1
                });


            })
            .catch((error) => {
                console.log(error);
            });

    }

    check22() {
        if (this.state.action) {
            //   console.log("entered");
            return (
                // <BrowserRouter>
                <Redirect
                    to={{
                        pathname: "/",
                        // state: {
                        //   token: this.state.token,
                        //   UserName: this.state.UserName,
                        // },
                    }}
                />
                // </BrowserRouter>
            );
        }
    }

}

export default ReactFontFace(Labeling, fontConfig);
